import React from "react";

const Select = ({
  name,
  label,
  optionValue,
  optionLabel,
  defaultValue,
  defaultLabel,
  options,
  optionLabelExtra,
  ...rest
}) => {
  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <select {...rest} name={name} className="form-control" id={name}>
        {defaultLabel && <option value={defaultValue}>{defaultLabel}</option>}
        {options
          ? options.map((option, index) => (
              <option
                key={index+" "+option[optionValue]}
                value={option[optionValue]}
              >
                {option[optionLabel]}{" "}
                {optionLabelExtra && ` - ${option[optionLabelExtra]}`}
              </option>
            ))
          : null}
      </select>
    </div>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Common/select.jsx